import React from 'react';
import firebase from '../../helper/firebase';
import _ from 'lodash';

import { Link } from 'react-router-dom';

import Head from '../../components/Head';
import JobCardHeader from '../../components/JobCardHeader';
import JobCardContent from '../../components/JobCardContent';
import UnpublishedJob from '../../components/UnpublishedJob';
import EmptyState from '../../components/EmptyState';
import LoggedOutCard from '../../components/LoggedOutCard';
import SkeletonCard from '../../components/SkeletonCard';
import SkeletonSectionTitle from '../../components/SkeletonSectionTitle';
import UnauthorizedText from '../../components/UnauthorizedText';

import { Title } from '../../helper/consts';

import Fade from 'material-ui/transitions/Fade';

import {
	Button,
	CircularProgress,
	Card,
	CardActions,
	Divider,
	Tabs,
	Tab
} from 'material-ui';

const style = {
	loading: {
		alignSelf: 'center',
		width: '75px',
		height: '75px',
		marginTop: 'calc(50vh - 37.5px - 64px)'
	}
};

export default class Jobs extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			archives: false
		};
	}

	componentWillUnmount() {
		this.props.uid &&
			this.props.loggedIn &&
			firebase
				.database()
				.ref(`myJobs/${this.props.uid}`)
				.off();
	}

	componentDidMount() {
		let references = [
			{
				uid: '',
				stateName: 'myJobs',
				dbName: 'myJobs',
				dispatchName: 'JobsState/GET_MYJOBS',
				getJobs: true
			}
		];
		this.props.actions.getMyListener(references);
	}

	handleArchive = (jid, status) => {
		firebase
			.database()
			.ref(`myJobs/${this.props.uid}/${jid}`)
			.update({ archived: status })
			.then(() => {
				this.props.actions.setSnack(
					true,
					`Success: ${!!status ? 'archived' : 'unarchived'}.`
				);
			})
			.catch(err => {
				this.props.actions.setSnack(true, 'Error: Please try again.');
			});
	};

	renderMyJobs = () => {
		const { myJobs, jobs } = this.props;
		const { archives } = this.state;
		// let jids = Object.keys(myJobs)
		// let jobDetails = [];
		// jids.forEach(jid => {
		//   if(!!this.props.jobs[jid]) { jobDetails.push(this.props.jobs[jid]) }
		// })
		let html = [];
		// if (_.isEmpty(Object.keys(myJobs).filter(jid => !!myJobs[jid].archived === !!archives)))
		if (
			_.isEmpty(myJobs) ||
			_.isEmpty(
				Object.keys(myJobs).filter(jid => !!myJobs[jid].archived === !!archives)
			)
		) {
			let card = (
				<EmptyState
					key="no jobs"
					subject={'No Jobs'}
					message={'Create a Job to start sharing and receiving applicants.'}
					btnDestination={'/AddJob'}
					btnMsg={'Add a Job'}
				/>
			);
			html.push(card);
			return html;
		} else {
			Object.keys(myJobs)
				.filter(jid => !!myJobs[jid].archived === !!archives)
				.filter(jid => !!jobs[jid])
				.map(jid => {
					let job = jobs[jid];
					job.oid = myJobs[jid].oid;
					return job;
				})
				.forEach(job => {
					let card = (
						<Fade key={job.jid} in={true}>
							<Card className="card">
								<JobCardHeader job={job} status={true} />
								<Divider light />
								{job.status !== 'published' ? null : (
									<JobCardContent job={job} wrap={true} />
								)}
								{job.status !== 'published' ? (
									<UnpublishedJob status={job.status} />
								) : null}
								<CardActions className="cardActions">
									<Link
										className="cardActionsBtn"
										to={`/Offer/${myJobs[job.jid].oid}`}
									>
										<Button raised>View</Button>
									</Link>
									<Link
										className="cardActionsBtn"
										to={`/Applicants/${job.jid}`}
									>
										<Button raised>Applicants</Button>
									</Link>
									{job.status !== 'published' &&
										!myJobs[job.jid].archived && (
											<Button
												className="cardActionsBtn"
												onClick={() => {
													this.handleArchive(job.jid, true);
												}}
												raised
												aria-label="Archive"
											>
												Archive
											</Button>
										)}
									{job.status !== 'published' &&
										!!myJobs[job.jid].archived && (
											<Button
												className="cardActionsBtn"
												onClick={() => {
													this.handleArchive(job.jid, false);
												}}
												raised
												aria-label="Unarchive"
											>
												Unarchive
											</Button>
										)}
									{job.status === 'hired' ? null : (
										<Link className="cardActionsBtn" to={`/EditJob/${job.jid}`}>
											<Button raised>Edit</Button>
										</Link>
									)}
								</CardActions>
							</Card>
						</Fade>
					);
					html.push(card);
				});
			if (html.length === 0) {
				let card = (
					<SkeletonCard
						key={'no_jobs_yet'}
						header={true}
						content={true}
						actions={true}
					/>
				);
				html.push(card);
				return html;
			}
			return html;
		}
	};

	handleTabChange = (e, value) => this.setState({ tab: value });

	renderTabs = () => {
		let html = [];
		let tabs = (
			<Tabs
				value={this.state.tab || 0}
				onChange={this.handleTabChange}
				indicatorColor="primary"
				textColor="primary"
				centered
				key="jobs_tabs"
			>
				<Tab
					onClick={() => {
						this.setState({ archives: false });
					}}
					label="Active"
				/>
				<Tab
					onClick={() => {
						this.setState({ archives: true });
					}}
					label="Archived"
				/>
			</Tabs>
		);
		html.push(tabs);
		return html;
	};

	render() {
		return (
			<React.Fragment>
				<Head title={`Jobs | ${Title}`} />
				<div id={this.props.loggedIn ? 'loggedInBody' : null} className="body">
					{this.props.authLoading && (
						<CircularProgress style={style.loading} size={75} />
					)}

					{this.props.loggedIn &&
						this.props.admin &&
						this.props.myJobsLoading && <SkeletonSectionTitle />}
					{this.props.loggedIn &&
						this.props.admin &&
						!this.props.myJobsLoading &&
						this.renderTabs()}

					{this.props.loggedIn &&
						this.props.admin &&
						this.props.myJobsLoading && (
							<SkeletonCard header={true} content={true} actions={true} />
						)}
					{this.props.loggedIn &&
						this.props.admin &&
						!this.props.myJobsLoading &&
						this.renderMyJobs()}

					{!this.props.authLoading && !this.props.loggedIn && <LoggedOutCard />}
					{!this.props.authLoading &&
						this.props.loggedIn &&
						!this.props.adminLoading &&
						!this.props.admin && (
							<div className="unauthorizedTextContainer">
								<UnauthorizedText
									text="Unauthorized"
									subText="Access is limited"
								/>
							</div>
						)}
				</div>
			</React.Fragment>
		);
	}
}



// WEBPACK FOOTER //
// ./src/pages/Jobs/Jobs.js